<template>
  <div>
    <ion-content>
      <ion-toolbar color="primary">
        <ion-title>Notifications</ion-title>
        <ion-buttons slot="start">
          <ion-button @click="close()">
            <font-awesome-icon slot="icon-only" icon="times"></font-awesome-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>

      <ion-list>
        <ion-item v-for="(notification, index) in notifications" v-bind:key="index">
          <ion-avatar slot="start">
            <img v-if="notification.data.image" v-bind:src="notification.data.image" />
          </ion-avatar>
          <ion-label class="ion-text-wrap">
            <h2>{{ notification.data.title }}</h2>
            <p>{{ notification.data.body }}</p>
          </ion-label>
        </ion-item>
      </ion-list>
    </ion-content>
  </div>
</template>

<script>
export default {
  name: "NotificationModal",
  data() {
    return {
      notifications: []
    };
  },
  methods: {
    close() {
      return this.$ionic.modalController.dismiss();
    }
  }
};
</script>